import { ProgramTheme, Segment, VerificationServiceValues, FaqUrl } from '@sheerid/jslib';

export const getFaqLink = (
    programTheme: ProgramTheme,
    segment: Segment,
    programId: VerificationServiceValues['programId'],
): FaqUrl => {
    let faqInTheme: FaqUrl;
    const urlParams = new URLSearchParams(window.location.search);
    const localeQS = urlParams.get('locale') || 'en';
    try {
        faqInTheme = programTheme.config.customFaqLink;
    } catch (e) {
        faqInTheme = '';
    }
    return (!faqInTheme || faqInTheme === '') ?
        `https://verify.sheerid.com/us-student-faq/?pid=${programId}&locale=${localeQS}` :
        faqInTheme;
};
